/**
 * <copy-eye-icon> - the "copy to the other eye" glyph: a copy icon with an arrow under it showing
 * where the values go. `direction` is "right" (the default), "left" or "down" - the other eye's
 * form beside this one, or its row below. Drawn in the current text colour. It sits inside an
 * icon-only round button (the vision form's adds, the prescription dialogs' copy right to left),
 * whose tooltip carries the explanation - the button itself has no text.
 */
app.component("copyEyeIcon", {
	bindings: { direction: "@" },
	template: `
<svg class="copy-eye-icon" viewBox="0 0 24 31" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
	<path d="M5.5,14.5 H4.5 Q2.5,14.5 2.5,12.5 V4.5 Q2.5,2.5 4.5,2.5 H12.5 Q14.5,2.5 14.5,4.5 V5.5"
		fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
	<rect x="8.5" y="8" width="13" height="12" rx="2" fill="none" stroke="currentColor" stroke-width="2"/>
	<g ng-if="!$ctrl.direction || $ctrl.direction === 'right'">
		<path d="M4.5,26.5 H17" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
		<path d="M14.5,23 L18.5,26.5 L14.5,30" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
	</g>
	<g ng-if="$ctrl.direction === 'left'">
		<path d="M19.5,26.5 H7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
		<path d="M9.5,23 L5.5,26.5 L9.5,30" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
	</g>
	<g ng-if="$ctrl.direction === 'down'">
		<path d="M12,22.5 V28" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
		<path d="M8.5,25.5 L12,29.5 L15.5,25.5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
	</g>
</svg>`,
});
